import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Page,
  PageSettingsModel,
  Reorder,
  Resize,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  EditSettingsModel,
  Inject,
  Toolbar,
  ToolbarItems,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import Message from '../../utils/Message/Message';
import { ThemeContext } from '../../context/theme.context';
import {  } from '../../services/CloudScheduler/CloudSchedulerServices';
import { all_information } from '../../App';
import { getBusinessLogicConfiguration } from '../../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
interface IProps {}
interface IState {
  data: any;
}
class OperationResourcesSchedulerList extends React.Component<IProps, IState> {
  private current_page: number = 2;
  private model: Array<any> = [];
  private current_query: String = '';
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  public editOptions: EditSettingsModel = {
    allowEditing: false,
    allowAdding: false,
    allowDeleting: false,
  };
  public toolbarOptions: ToolbarItems[] = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    'ColumnChooser',
    'Search',
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
    pageSizes: true,
  };
  private gridTableView: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      data: [],
    };
  }
  componentDidMount() {
    if (this.context.planId != 0) {
      this.getOperationResources(this.context.planId);
    }
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (this.context.isResourcesAllowChange) {
      this.model=[];
      if (this.context.planId != 0) {
        this.getOperationResources(this.context.planId);
      }
      this.context.setResourcesAllowChange(false);
    }
  }
  async getOperationResources(plan_id: number) {
    await getBusinessLogicConfiguration({org_id:all_information.company_id})
      .then((el) => {
        this.current_query = '';
        el.data.map((elin: any) => {
          if (elin.component_name === 'Cloud Scheduler') {
            this.current_query += elin.condition + ' and';
          }
        });
        if (this.current_query !== '') {
          this.current_query = this.current_query.replaceAll('=', '€');
          this.current_query = this.current_query.substring(
            0,
            this.current_query.lastIndexOf('and')
          );
          this.getTableData('1$500$' + this.current_query + '$$' + plan_id);
        } else {
          this.getTableData('1$500$' + this.current_query + '$$' + plan_id);
        }
      })
      .catch((er) => {
        //("Can't acces business logic parameter");
        Message.error("Can't acces business logic parameter");
        this.getTableData('1$500$' + this.current_query + '$$' + plan_id);
        if (er.response) {
          Message.error(er.response.data+"\n"+er.response.status+"\n"+er.response.headers);
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  getTableData(range: string) {
    // GetOperationResourcesSchedulerList(range).then(
    //   (result) => {
    //     this.model = result.data;
    //     let dataAll = result.data.map((res: any) => {
    //       return {
    //         ...res,
    //         Planned_Start_Date: this.ConvertToDate(res.Planned_Start_Date),
    //         Planned_Start_Time: this.ConvertToDate(res.Planned_Start_Time),
    //         Planned_Finish_Date: this.ConvertToDate(res.Planned_Finish_Date),
    //         Planned_Finish_Time: this.ConvertToDate(res.Planned_Finish_Time),
    //       };
    //     });
    //     this.setState({ data: dataAll });
    //     this.gridTableView.refresh();
    //   }
    // );
  }
  ConvertToDate(val: any) {
    var num = parseInt(val.substring(6, 19));
    var date = new Date(num);
    const month = date.getMonth();
    const day = date.getDate();
    const year = date.getFullYear();
    const result =
      (day < 10 ? '0' + day : day) +
      '/' +
      (month < 10 ? '0' + month : month) +
      '/' +
      year;
    return result;
  }
  begin(args: any) {
    if (args.requestType === 'paging') {
      if (args.currentPage > args.previousPage) {
        if (args.currentPage >= this.current_page) {
          this.current_page++;
          var pS = (this.gridTableView as GridComponent).pageSettings.pageSize;
          var start_index = (this.current_page - 1) * Number(pS) + 1;
          var end_index = start_index + (Number(pS) - 1);
          this.getTableData(`${start_index}$${end_index}`);
        }
      } else if (args.currentPage === args.previousPage) {
        var pS = (this.gridTableView as GridComponent).pageSettings.pageSize;
        var last_page = this.model.length / Number(pS);
        this.current_page = last_page;
      }
    }
  }
  public render() {
    return (
      <GridComponent
        id='gridOperationResourcesSchedulerList'
        dataSource={this.state.data}
        editSettings={this.editOptions}
        toolbar={this.toolbarOptions}
        ref={(g) => (this.gridTableView = g)}
        filterSettings={this.FilterOptions}
        allowFiltering={true}
        showColumnChooser={true}
        allowPaging={true}
        enablePersistence={true}
        pageSettings={this.pageOptions}
        showColumnMenu={true}
        allowReordering={true}
        allowResizing={true}
        allowGrouping={true}
        style={{ marginTop: '10px' }}
        //toolbarClick={this.toolbarClick.bind(this)}
        actionBegin={this.begin.bind(this)}
        gridLines='Both'
        //  queryCellInfo={this.cellRender}
        // rowSelected={this.rowselect.bind(this)}
        height='calc(-250px + 100vh)'
      >
        <ColumnsDirective>
          <ColumnDirective field='resourceName' headerText='Resources Name ' />
          <ColumnDirective field='order_code' headerText='Work Order Number' />
          <ColumnDirective field='Asset_Number' headerText='Asset Number' />
          <ColumnDirective field='Description' headerText='Description' />
          <ColumnDirective field='Trade' headerText='Trade' />
          <ColumnDirective field='Est_Hours' headerText='Est Hours' />
          <ColumnDirective field='Required' headerText='Required' />
          <ColumnDirective field='Order_Type' headerText='Work Order Type' />
          <ColumnDirective field='Priority' headerText='Priority' />
          <ColumnDirective field='Section' headerText='Section' />
          <ColumnDirective
            field='Order_Status'
            headerText='Work Order Status'
          />

          <ColumnDirective
            field='Planned_Start_Date'
            headerText='Planned Start Date'
            format='dd/MM/yyyy'
          />
          <ColumnDirective
            field='Planned_Start_Time'
            headerText='Planned Start Time'
            format='dd/MM/yyyy'
          />
          <ColumnDirective
            field='Planned_Finish_Date'
            headerText='Planned Finish Date'
            format='dd/MM/yyyy'
          />
          <ColumnDirective
            field='Planned_Finish_Time'
            headerText='Planned Finish Time'
            format='dd/MM/yyyy'
          />
          <ColumnDirective field='Actual_Hours' headerText='Actual Hours' />
          <ColumnDirective field='Responsibility' headerText='Responsibility' />
          <ColumnDirective field='Planned_By' headerText='Planned By' />
          <ColumnDirective field='OP_INT_ID' headerText='OP INT ID' />
          <ColumnDirective field='Planned_By' headerText='Planned By' />
          <ColumnDirective field='Planned_By' headerText='Planned By' />
          <ColumnDirective field='Planned_By' headerText='Planned By' />
          <ColumnDirective field='Planned_By' headerText='Planned By' />
        </ColumnsDirective>
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnChooser,
            ColumnMenu,
            Resize,
            Group
          ]}
        />
      </GridComponent>
    );
  }
}
export default OperationResourcesSchedulerList;
